import React, { useCallback } from 'react'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'
import AvatarPicker from './AvatarPicker'

const TemplateCover = ({ form, template }) => {
  const onSubmit = useCallback(
    (avatar) => {
      if (!avatar || typeof avatar !== 'object') return
      form.setValue('coverField', 'cover')
      form.setValue('cover', avatar.url)
      form.setValue('initDataId', avatar.id)
      const isSpine = avatar?.engineWith === 'spine'
      form.setValue('videoCover', isSpine ? avatar.videoUrl || '' : '')
      form.setValue(
        'videoCoverPreview',
        isSpine ? avatar.videoPreviewUrl || '' : '',
      )
    },
    [form],
  )

  const initDataId = form.watch('initDataId', template.initDataId)

  return (
    <div className="space-y-2">
      <Label>Cover</Label>
      <p className="text-sm text-muted-foreground">
        从已上传的 Avatar 中选择一个作为 Cover。
      </p>
      <div className="flex gap-2">
        <input
          type="text"
          value={initDataId || ''}
          readOnly
          placeholder="未选择 Avatar"
          className="flex-1 px-3 py-2 border rounded-md bg-muted/50 text-xs"
        />
        <AvatarPicker
          original={template.initDataId}
          template={template}
          form={form}
          onSubmit={onSubmit}
        >
          <Button type="button" variant="outline">
            选择 Avatar
          </Button>
        </AvatarPicker>
      </div>
    </div>
  )
}

export default TemplateCover
